<template>
  <div class="flex-fill flex flex-column" style="overflow-y: auto;">
    <div class="bgc-white flex-auto flex flex-row h-center v-center">
      <h4 style="margin-bottom: 0;">{{ title }}</h4>
    </div>
    <div class="bgc-white flex-auto" style="padding: 0px 15px;">
      <pre class="qaac-description">{{ description }}</pre>
    </div>
    <div class="flex-auto" style="padding: 0px 15px 15px; margin-bottom: 5px;">
      <div style="padding: 5px 15px;">
        提交人：
        <span style="color: #5d9cec;">{{ creatorName }}</span>
      </div>
      <div style="padding: 5px 15px;">提交时间：{{ createdAt }}</div>
      <div style="padding: 5px 15px;">标签：{{ tags }}</div>
    </div>
    <div
      class="flex-fill"
      style="padding: 0px 15px 15px; background-color: #fff;"
    >
      <ul style="padding: 0; list-style: none;">
        <li v-for="item in items" :key="item.order">
          <answer-blank-item-mobile
            :title="item.title"
            :description="item.description"
            :order="item.order"
            :schema="item.schema"
            :pictures="item.pictures"
            :type="item.type"
            :value="item.value"
            :extra="item.extra"
          ></answer-blank-item-mobile>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import AnswerBlankItemMobile from "@/components/share/BlankItemMobile";
export default {
  name: "share-answer-mobile",
  components: {
    AnswerBlankItemMobile,
  },
  props: {
    form: Object,
    answer: Object,
    creatorName: String,
    sourceChannel: String,
    os: String,
    tags: String,
    items: Array,
  },
  computed: {
    title() {
      return this.form.title;
    },
    description() {
      return this.form.description;
    },
    createdAt() {
      return this.answer.createdAt;
    },
  },
  data() {
    return {
      visible: false,
      shareUrl: location.href,
    };
  },
  methods: {
    goBack() {
      const event = "back-parent";
      if (this.$listeners[event]) {
        this.$emit(event);
      }
    },
  },
};
</script>
